// CRAFT COMMERCE CONSTANTS, SETTINGS, & HELPERS


// PRODUCT TYPES
// ===============================================================================================

/** @type {String} **/
export const MENUS_PRODUCT_TYPE = 'menus';
/** @type {Number} **/
export const MENUS_PRODUCT_TYPE_ID = 3;
/** @type {String} **/
export const DISHES_PRODUCT_TYPE = 'dishes';
/** @type {Number} **/
export const DISHES_PRODUCT_TYPE_ID = 2;
/** @type {String} **/
export const DRINKS_PRODUCT_TYPE = 'drinks';
/** @type {Number} **/
export const DRINKS_PRODUCT_TYPE_ID = 5;
/** @type {String} **/
export const ACCESSORIES_PRODUCT_TYPE = 'accessories';
/** @type {Number} **/
export const ACCESSORIES_PRODUCT_TYPE_ID = 4;

/**
 * Get a `Product` type handle for a given ID.
 *
 * @param productTypeId {Number|String}
 * @return {String|null}
 */
export const productTypeHandleFromId = (productTypeId) => {
   if (typeof productTypeId === 'string') {
      productTypeId = parseInt(productTypeId);
   }

   if (typeof productTypeId === 'number') {
      switch (productTypeId) {
         case MENUS_PRODUCT_TYPE_ID:
            return MENUS_PRODUCT_TYPE;
         case DISHES_PRODUCT_TYPE_ID:
            return DISHES_PRODUCT_TYPE;
         case DRINKS_PRODUCT_TYPE_ID:
            return DRINKS_PRODUCT_TYPE;
         case ACCESSORIES_PRODUCT_TYPE_ID:
            return ACCESSORIES_PRODUCT_TYPE;
      }
   }

   return null;
};

/**
 * Get a `Product` type ID for a given handle.
 *
 * @param productTypeHandle {String}
 * @return {Number|null}
 */
export const productTypeIdFromHandle = (productTypeHandle) => {
   if (typeof productTypeHandle === 'string') {
      switch (productTypeHandle) {
         case MENUS_PRODUCT_TYPE:
            return MENUS_PRODUCT_TYPE_ID;
         case DISHES_PRODUCT_TYPE:
            return DISHES_PRODUCT_TYPE_ID;
         case DRINKS_PRODUCT_TYPE:
            return DRINKS_PRODUCT_TYPE_ID;
         case ACCESSORIES_PRODUCT_TYPE:
            return ACCESSORIES_PRODUCT_TYPE_ID;
      }
   }

   return null;
};


// ADJUSTMENT TYPES
// ===============================================================================================

/** @type {String} **/
export const SHIPPING_ADJUSTER_TYPE = 'shipping';
/** @type {String} **/
export const DISCOUNT_ADJUSTER_TYPE = 'discount';
/** @type {String} **/
export const TAX_ADJUSTER_TYPE = 'tax';

// GATEWAYS
// ===============================================================================================

// these must match the gateway IDs from Craft Commerce
/** @type {Number} **/
export const BANK_TRANSFER_GATEWAY_ID = 3;
/** @type {Number} **/
export const CARD_GATEWAY_ID = 4;
/** @type {Number} **/
export const INVOICE_GATEWAY_ID = 2;
/** @type {Number} **/
export const PAYPAL_GATEWAY_ID = 1;
/** @type {Number} **/
export const SOFORT_GATEWAY_ID = 5;

// Product IDs (Commerce)
// ===================================================================================
export const PRODUCT_MENU_BUFFET_BASIC = 928;

// Menu Categories
// ===================================================================================
export const CATEGORY_MENU_CATEGORY_BUFFET = 773;